<template>
  <Modal title="老师对学生的评价" v-model="visible">
    <Form v-show="!isUpdate" class="score-feedback form" :label-width="80">
      <Row style="margin-bottom: 10px">
        <Col :span="10" :offset="3">
          <h3>1.词汇与运用: <span style="color:green"> {{ vocabularyTotal }} </span> </h3>
        </Col>
        <Col :span="10">
          <h3>2.听力与口语: <span style="color:green"> {{ listenTotal }} </span> </h3>
        </Col>
      </Row>
      <Row>
        <Col :span="10" :offset="3">
          <Form-item label="词汇应用："><label>{{ score[0] }}</label></Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="听力理解："><label>{{ score[5] }}</label></Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="10" :offset="3">
          <Form-item label="词汇理解："><label>{{ score[1] }}</label></Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="声调辨别："><label>{{ score[6] }}</label></Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="10" :offset="3">
          <Form-item label="清晰表达："><label>{{ score[2] }}</label></Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="篇章表达："><label>{{ score[7] }}</label></Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="10" :offset="3">
          <Form-item label="表达语速："><label>{{ score[3] }}</label></Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="发音准确："><label>{{ score[8] }}</label></Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="10" :offset="3">
          <Form-item label="语法精准："><label>{{ score[4] }}</label></Form-item>
        </Col>
        <Col :span="10">
          <Form-item label="互动参与："><label>{{ score[9] }}</label></Form-item>
        </Col>
      </Row>
      <Row style="margin-top: 5px; margin-bottom: 10px">
        <Col :span="6" :offset="3">
          <h3>总的分数: <span style="color:green"> {{ total }} </span> </h3>
        </Col>
        <Col :span="10">
          <h3> {{ scroeLevel }} </h3>
        </Col>
      </Row>
      <Row>
        <Col :span="20" :offset="3">
          <h3>老师评价：</h3>
          <h4>今天总评价:</h4>
          <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.General_Description.General_Description_1}}</span> did a great job in class today!
          <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.General_Description.General_Description_2}}</span> were able to <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.General_Description.General_Description_3}}</span>.
          You participated in <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.General_Description.General_Description_4}}</span>.
          <h4>今天学习的单元:</h4>
          We studied <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Unit}}</span>.
          <h4>今天我们学了:</h4>
          This level includes vocabulary concerning <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Learning_Content.Learning_Content_1}}</span>.
          Today's key vocabulary terms were <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Learning_Content.Learning_Content_2}}</span>, You were able to use <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Learning_Content.Learning_Content_3}}</span>.
          And you learned phonics <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Learning_Content.Learning_Content_4}}</span>. and can pronounce <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Learning_Content.Learning_Content_5}}</span>.
          <h4>今天你还可以更棒:</h4>
          <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suggestion.Suggestion_1}}</span> did a good job with <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suggestion.Suggestion_2}}</span>.
          I recommend practice the grammar <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suggestion.Suggestion_3}}</span> in your Hellokid textbook, especially
          <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suggestion.Suggestion_4}}</span>
          and pay attention to the pronunciation of <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suggestion.Suggestion_5}}</span>.
          <h4>适合的课程级别和上课频率:</h4>
          <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Suitable_level}}</span> a perfect fit for you to start the journey of learning English,
          and twice or three times a week are suitable for you to have great outcome.
          <h4>今日寄语:</h4>
          Overall I am very pleased with our first class together. Great work today <span style='text-decoration:underline;'>{{assessmentLessonEvaluation.Ending_words}}</span>!
          I look forward to seeing you again soon in the classroom.
        </Col>
      </Row>
      <Row>
        <Col :span="22" :offset="3">
        <h3>评论时间：</h3>
        <label>{{ feedTime }}</label>
        </Col>
      </Row>
    </Form>
    <Form v-show="isUpdate" ref="feedbakcForm" class="score-feedback form" :label-width="80">
      <Row style="margin-bottom: 10px">
        <Col :span="10" :offset="3">
          <h3>1.词汇与运用: <span style="color:green"> {{ vocabularyTotal }} </span> </h3>
        </Col>
        <Col :span="10">
          <h3>2.听力与口语: <span style="color:green"> {{ listenTotal }} </span> </h3>
        </Col>
      </Row>
      <Row>
        <Col :span="8" :offset="3">
          <Form-item label="词汇应用：">
            <Select v-model="score[0]" size="small" @on-change="scoreCompute">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="8" :offset="2">
          <Form-item label="听力理解：">
            <Select v-model="score[5]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="8" :offset="3">
          <Form-item label="词汇理解：">
            <Select v-model="score[1]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="8" :offset="2">
          <Form-item label="声调辨别：">
            <Select v-model="score[6]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="8" :offset="3">
          <Form-item label="清晰表达：">
            <Select v-model="score[2]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="8" :offset="2">
          <Form-item label="篇章表达：">
            <Select v-model="score[7]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="8" :offset="3">
          <Form-item label="表达语速：">
            <Select v-model="score[3]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="8" :offset="2">
          <Form-item label="发音准确：">
            <Select v-model="score[8]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :span="8" :offset="3">
          <Form-item label="语法精准：">
            <Select v-model="score[4]" size="small">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :span="8" :offset="2">
          <Form-item label="互动参与：">
            <Select v-model="score[9]" size="small" @on-change="scoreCompute">
              <Option v-for="item in scroePoints" :value="item" :key="item">{{ item }}</Option>
            </Select>
          </Form-item>
        </Col>
      </Row>
      <Row style="margin-top: 5px; margin-bottom: 10px">
        <Col :span="6" :offset="3">
          <h3>总的分数: <span style="color:green"> {{ total }} </span> </h3>
        </Col>
        <Col :span="10">
          <h3> {{ scroeLevel }} </h3>
        </Col>
      </Row>
      <Row>
        <Col :span="22" :offset="1">
        <h3>老师评价：</h3>
        <h4>今天总评价:</h4>
        <Row>
          <Form-item prop="evaluation" :label-width="1">
            <Input  size="small" autosize v-model="assessmentLessonEvaluation.General_Description.General_Description_1" ></Input>
          </Form-item>did a great job in class today!
        <Form-item prop="evaluation" :label-width="1">
          <Input  size="small" autosize v-model="assessmentLessonEvaluation.General_Description.General_Description_2" ></Input>
        </Form-item>were able to
        <Form-item prop="evaluation" :label-width="1">
          <Input size="small" autosize v-model="assessmentLessonEvaluation.General_Description.General_Description_3" ></Input>
        </Form-item>
        You participated in
        <Form-item prop="evaluation" :label-width="1">
          <Input size="small" autosize v-model="assessmentLessonEvaluation.General_Description.General_Description_4" ></Input>
        </Form-item>
        </Row>
        <h4>今天学习的单元:</h4>
        We studied  <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Unit" ></Input>
      </Form-item>
        <h4>今天我们学了:</h4>
        This level includes vocabulary concerning
        <Form-item prop="evaluation" :label-width="1">
          <Input size="small" autosize v-model="assessmentLessonEvaluation.Learning_Content.Learning_Content_1" ></Input>
        </Form-item>
        Today's key vocabulary terms were <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Learning_Content.Learning_Content_2" ></Input>
      </Form-item> You were able to use <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Learning_Content.Learning_Content_3" ></Input>
      </Form-item>
        And you learned phonics <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Learning_Content.Learning_Content_4" ></Input>
      </Form-item> and can pronounce <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Learning_Content.Learning_Content_5" ></Input>
      </Form-item>
        <h4>今天你还可以更棒:</h4>
        <Form-item prop="evaluation" :label-width="1">
          <Input size="small" autosize v-model="assessmentLessonEvaluation.Suggestion.Suggestion_1" ></Input>
        </Form-item>
          did a good job with <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Suggestion.Suggestion_2" ></Input>
      </Form-item>
        I recommend practice the grammar <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Suggestion.Suggestion_3" ></Input>
      </Form-item> in your Hellokid textbook, especially <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Suggestion.Suggestion_4" ></Input>
      </Form-item>
        and pay attention to the pronunciation of <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Suggestion.Suggestion_5" ></Input>
      </Form-item>
        <h4>适合的课程级别和上课频率:</h4>
        <Form-item prop="evaluation" :label-width="1">
          <Input size="small" autosize v-model="assessmentLessonEvaluation.Suitable_level" ></Input>
        </Form-item> a perfect fit for you to start the journey of learning English,
        and twice or three times a week are suitable for you to have great outcome.
        <h4>今日寄语:</h4>
        Overall I am very pleased with our first class together. Great work today <Form-item prop="evaluation" :label-width="1">
        <Input size="small" autosize v-model="assessmentLessonEvaluation.Ending_words" ></Input>
      </Form-item>!
        I look forward to seeing you again soon in the classroom.
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button v-show="!isUpdate && !readonly" type="primary" size="large" @click="isUpdate=true" >编辑</Button>
      <Button v-show="isUpdate" type="primary" size="large" :loading="loadingUpdate" @click="update" >保存</Button>
    </div>
  </Modal>
</template>
<style>
.score-feedback .ivu-form-item {
  margin-bottom: 0px;
}
</style>
<script>
  export default {
    name: 'BookTchScoreFeedbackModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      openedId: {
        type: Number
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        feedTime: '',
        visible: this.value,
        isUpdate: false,
        loadingUpdate: false,
        score: {},
        vocabularyTotal: '',
        listenTotal: '',
        total: '',
        assessmentLessonEvaluation: {
          General_Description: {},
          Learning_Content: {},
          Suggestion: {},
        },
        scroeLevel: '',
        scroePoints: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
        scroeAlias: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'],
        scroeLevelList: ['Zero Level-Level 0', 'Basic-Level 1', 'Low Beginner-Level 2',
          'Beginner-Level 3', 'Low Intermediate-Level 4',
          'Intermediate-Level 5', 'Low advanced-Level 6', 'Advanced-Level 7'],
        feedback: {
        },
        feedbackRule: {
          learnedComment: [
            { type: 'string', required: true, message: '学习内容评价', trigger: 'blur' }
          ],
          goodComment: [
            { type: 'string', required: true, message: '表现好的评价', trigger: 'blur' }
          ],
          betterComment: [
            { type: 'string', required: true, message: '请填写可以改进的评价', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      onLoad () {
        let self = this
        let loadMsg = this.$Message.loading('正在加载中...', 0)
        self.assessmentLessonEvaluation = null
        self.$http.get('/bookTchFeedback/queryByLsnOpenId', { params: {lsnOpenId: self.openedId} }).then(function (res) {
          loadMsg()
          if (!res || !res.data) {
            self.$emit('on-close')
            return
          }
          self.feedback = res.data
          self.score = JSON.parse(res.data.scoreComment)
          if (res.data.assessmentLessonEvaluation != null) {
            self.assessmentLessonEvaluation = JSON.parse(res.data.assessmentLessonEvaluation)
          }
          if (self.assessmentLessonEvaluation === null) {
            self.assessmentLessonEvaluation = {}
            self.assessmentLessonEvaluation.Learning_Content = {}
            self.assessmentLessonEvaluation.Suggestion = {}
            self.assessmentLessonEvaluation.General_Description = {}
            self.assessmentLessonEvaluation.General_Description.General_Description_1 = ''
            self.assessmentLessonEvaluation.General_Description.General_Description_2 = ''
            self.assessmentLessonEvaluation.General_Description.General_Description_3 = ''
            self.assessmentLessonEvaluation.General_Description.General_Description_4 = ''
            self.assessmentLessonEvaluation.Unit = ''
            self.assessmentLessonEvaluation.Learning_Content.Learning_Content_1 = ''
            self.assessmentLessonEvaluation.Learning_Content.Learning_Content_2 = ''
            self.assessmentLessonEvaluation.Learning_Content.Learning_Content_3 = ''
            self.assessmentLessonEvaluation.Learning_Content.Learning_Content_4 = ''
            self.assessmentLessonEvaluation.Learning_Content.Learning_Content_5 = ''
            self.assessmentLessonEvaluation.Suggestion.Suggestion_1 = ''
            self.assessmentLessonEvaluation.Suggestion.Suggestion_2 = ''
            self.assessmentLessonEvaluation.Suggestion.Suggestion_3 = ''
            self.assessmentLessonEvaluation.Suggestion.Suggestion_4 = ''
            self.assessmentLessonEvaluation.Suggestion.Suggestion_5 = ''
            self.assessmentLessonEvaluation.Suitable_level = ''
            self.assessmentLessonEvaluation.Ending_words = ''
          }
          self.feedTime = res.data.gmtModified
          self.visible = true
        })
      },
      update () {
        let self = this
        this.$refs.feedbakcForm.validate((valid) => {
          if (!valid) {
            return
          }
          self.loadingUpdate = true
          let params = self.feedback
          params.lsnOpenId = self.openedId
          params.scoreComment = JSON.stringify(this.score)
          params.assessmentLessonEvaluation = JSON.stringify(this.assessmentLessonEvaluation)
          self.$http.post('/bookTchFeedback/update', params).then(function (res) {
            self.loadingUpdate = false
            if (res && res.data > 0) {
              self.$Message.success('保存成功!')
              self.visible = false
            }
          }).catch(function (e) {
            self.loadingUpdate = false
          })
        })
      },
      scoreCompute () {
        let score = this.score
        this.vocabularyTotal = parseInt(score['0']) + parseInt(score[1]) + parseInt(score[2]) + parseInt(score[3]) + parseInt(score[4])
        this.listenTotal = parseInt(score[5]) + parseInt(score[6]) + parseInt(score[7]) + parseInt(score[8]) + parseInt(score[9])
        this.total = this.vocabularyTotal + this.listenTotal
        this.scroeLevel = this.scroeLevelList[(this.total - 1) / 10 > 7 ? 7 : parseInt((this.total - 1) / 10)]
      },
    },
    watch: {
      value (val) {
        if (val === true) {
          this.onLoad()
        } else {
          this.feedback = {}
          this.visible = val
        }
      },
      score (val) {
        this.scoreCompute()
      },
      visible (val) {
        this.isUpdate = false
        this.$emit('input', val)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// BookTchScoreFeedbackModal.vue?146f3fd7